import M from '@block/utils';

interface EventDetail {
  [key: string]: unknown;
}

/**
 * 用于 logan 的自定义埋点上报
 * @param eventName 事件名称
 * @param eventDetail 可以是接口信息，也可以是其他信息，可以是string，也可以是包含其他信息的对象
 */
const loganCustomReport = (eventName: string, eventDetail?: string | EventDetail) => {
  try {
    const pathName = window?.location?.pathname ?? 'pathname缺失';
    // cspell:disable-next-line
    const currentTime = M.datejs().format('YYYY-MM-DD HH:mm:ss.SSS');
    const reportDetail = {
      pathName,
      currentTime,
      eventName,
      eventDetail,
    };
    window?.Logan?.log(
      `loganCustomReport: eventName:${eventName || ''}, reportDetail: ${JSON.stringify(reportDetail)}`,
    );
  } catch (error) {
    window?.Logan?.log(`loganCustomReport Error: eventName:${eventName || ''}, reportDetail: ${JSON.stringify(error)}`);
  }
};

/**
 * 用于 raptor 的自定义埋点上报
 * @param eventName 事件名称
 * @param eventDetail 可以是接口信息，也可以是其他信息，可以是string，也可以是包含其他信息的对象
 */
const raptorCustomReport = (eventName: string, eventDetail?: string | EventDetail) => {
  try {
    window?.owl?.(
      'addError',
      {
        name: 'raptorCustomReport',
        msg: `eventName:${eventName || ''}`,
      },
      {
        level: 'info',
        category: 'customError',
        resourceUrl: window?.location?.href ?? 'resourceUrl缺失',
        tags: {
          eventName: JSON.stringify(eventName),
          eventDetail: JSON.stringify(eventDetail),
          type: 'raptorCustomReport',
        },
      },
    );
  } catch (error) {
    window?.owl?.(
      'addError',
      {
        name: 'raptorCustomReport Error',
        msg: `eventName:${eventName || ''}`,
      },
      {
        level: 'info',
        category: 'customError',
        resourceUrl: window?.location?.href ?? 'resourceUrl缺失',
        tags: {
          data: JSON.stringify(error),
          type: 'raptorCustomReport Error',
        },
      },
    );
  }
};

/**
 * 用于 raptor & logan 的自定义埋点上报，自动收集pathName、currentTime
 * @param eventName 事件名称
 * @param eventDetail 可以是接口信息，也可以是其他信息，可以是string，也可以是包含其他信息的对象
 */
const customReport = (eventName: string, eventDetail?: string | EventDetail) => {
  try {
    loganCustomReport(eventName, eventDetail);
    raptorCustomReport(eventName, eventDetail);
  } catch (error) {
    console.log('customReport error', error);
  }
};

export { loganCustomReport, raptorCustomReport, customReport };
